import {
  ETipoQuestPergunta,
  IAtitudeLegenda,
  ILegenda,
  IQuestPergunta,
  IQuestResposta,
} from "@deltasge/marauders-map";
import { Grid } from "@mui/material";
import React, { FC } from "react";
import { DiscursivaComponent } from "./DiscursivaComponent";
import { AtitudesComponent } from "./AtitudesComponent";
import { LegendasComponent } from "./LegendasComponent";
import { AlternativasComponent } from "./AlternativasComponent";

export const RespostaComponent: FC<{
  pergunta: IQuestPergunta;
  resposta: IQuestResposta;
  atitudes?: IAtitudeLegenda[];
  legendas?: ILegenda[];
  qtdeEtapas: number;
  nomeEtapa: string;
  etapaAtual: number;
  setResposta: (resposta: IQuestResposta) => void;
}> = ({
  pergunta,
  atitudes,
  legendas,
  qtdeEtapas,
  nomeEtapa,
  etapaAtual,
  resposta,
  setResposta,
}) => {
  return (
    <Grid container spacing={2}>
      {Array.from({ length: qtdeEtapas }, (_, etapa) => {
        const index = (etapa + 1) as 1 | 2 | 3 | 4;
        let keyDiscursiva:
          | "respostaDiscursiva"
          | "respostaDiscursiva1"
          | "respostaDiscursiva2"
          | "respostaDiscursiva3"
          | "respostaDiscursiva4" = "respostaDiscursiva";
        let keyMultObj:
          | "respostaMultipla"
          | "respostaMultipla1"
          | "respostaMultipla2"
          | "respostaMultipla3"
          | "respostaMultipla4" = "respostaMultipla";

        if (qtdeEtapas > 1) {
          keyDiscursiva = `respostaDiscursiva${index}`;
          keyMultObj = `respostaMultipla${index}`;
        }
        const discursiva = resposta[keyDiscursiva];
        const mulObj = resposta[keyMultObj];

        return (
          <Grid
            item
            key={`${pergunta.id}-${etapa}`}
            xs={qtdeEtapas == 1 ? 12 : qtdeEtapas == 3 ? 4 : 3}
          >
            {pergunta.tipo == ETipoQuestPergunta.Discursiva && (
              <DiscursivaComponent
                discursiva={discursiva || ""}
                etapa={etapa}
                etapaAtual={etapaAtual}
                nomeEtapa={nomeEtapa}
                setDiscursiva={(value) => {
                  resposta[keyDiscursiva] = value;
                  setResposta(resposta);
                }}
                qtdeEtapas={qtdeEtapas}
              />
            )}
            {pergunta.tipo == ETipoQuestPergunta.Atitudes && atitudes && (
              <AtitudesComponent
                atitudes={atitudes}
                etapa={etapa}
                etapaAtual={etapaAtual}
                nomeEtapa={nomeEtapa}
                qtdeEtapas={qtdeEtapas}
                value={mulObj || ""}
                setValue={(value) => {
                  resposta[keyMultObj] = value;
                  setResposta(resposta);
                }}
              />
            )}
            {pergunta.tipo == ETipoQuestPergunta.Menções && legendas && (
              <LegendasComponent
                etapa={etapa}
                etapaAtual={etapaAtual}
                legendas={legendas}
                nomeEtapa={nomeEtapa}
                qtdeEtapas={qtdeEtapas}
                value={mulObj || ""}
                setValue={(value) => {
                  resposta[keyMultObj] = value;
                  setResposta(resposta);
                }}
              />
            )}
            {(pergunta.tipo == ETipoQuestPergunta["Multipla Escolha"] ||
              pergunta.tipo == ETipoQuestPergunta.Objetiva) &&
              pergunta.ordens && (
                <AlternativasComponent
                  etapa={etapa}
                  etapaAtual={etapaAtual}
                  nomeEtapa={nomeEtapa}
                  pergunta={pergunta}
                  qtdeEtapas={qtdeEtapas}
                  value={mulObj || ""}
                  setValue={(value) => {
                    resposta[keyMultObj] = value;
                    setResposta(resposta);
                  }}
                />
              )}
          </Grid>
        );
      })}
    </Grid>
  );
};
